import { createAction } from 'redux-actions';

import { PERIODS } from 'utils/constants';
import { SET_DAILY_ACTIVE_USERS_PERIOD } from './actionTypes';

export const setDailyActiveUsersPeriod = createAction<PERIODS>(
  SET_DAILY_ACTIVE_USERS_PERIOD
);
